import {useEffect} from 'react'
import {EditModalHeader} from './EditModalHeader'
import {EditModalFormWrapper} from './EditModalFormWrapper'

type Props = {
  userID: string
  editUsertype?: string
}

const EditModal: React.FC<Props> = ({userID, editUsertype}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-lg'>
          {/* begin::Modal content */}
          <div className='modal-content '>
            <EditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body pt-2'>
              <EditModalFormWrapper userID={userID} editUsertype = {editUsertype} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {EditModal}
